// cspell:disable
/* eslint-disable */
import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from "react";
// import UploadOptions from "./uploadOptions/index";
import FilesWrapperExternal from "./FilesWrapperExternal.jsx";
// import useTheme from "hooks/observer";
import {File as IzFile,Folder as IzFolder} from "@induz/sdk";
import StorageFail from "../storageFail/index";
import UploadOptions from "../uploadOptions/index";
import { useToast } from "components/Toaster/index";
import { normalizeName } from "utils/normalizeName";
import TaskMonitor from "../TaskMonitor/index";
import { TaskManager } from "@induz/sdk";
import { Share  } from "@induz/sdk";// import { format } from "prettier";
// import "../table/table.scss";
import "../Ysafe.scss";
const YsafeExternal = forwardRef(({
  ObjectsInSpace,
  onStateSync,
  searchQuery,
  setSearchQuery,
  sortSelected,
  setSortSelected,
  isSortRotated,
  setIsSortRotated,
  layout,
  setLayout
}, ref) => {
  //TODO:remove this later
  // ObjectsInSpace=InfoOfExternalObjects.getTestInfoOfExternalObjects(4);
  // console.log("ObjectsInSpace in ysafe external ",ObjectsInSpace);
  // const [show, setShow] = useState(false);
  const [filesList, setFilesList] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [modal, setModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [isDropDownVisible, setIsDropDownVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [progress, setProgress] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [cancelUploadModal, setCancelUploadModal] = useState(false);
  const [showLoadingProgress, setShowLoadingProgress] = useState(false);
  const [uploadFolder, setUploadFolder] = useState(false);

  const listedFolders = useRef(new IzFolder());

  const totalPages = useRef(1);
  const [fetching, setFetching] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [UUIDArrays,setUUIDArrays]=useState([]);

  const [filesData, setFilesData] = useState([]); // Stores the fetched files/folders
  const [length, setLength] = useState(0);
  const [currentPath, setCurrentPath] = useState(["external_shared"]); // Stores folder navigation path
  const [checkedRows, setCheckedRows] = useState({});
  const [showingSection, setShowingSection] = useState(0); // Stores section names
  const [namesArrays, setNamesArrays] = useState();
  const [typesArrays, setTypesArrays] = useState();
  const [sizeArrays, setSizeArrays] = useState();
  const [modifiedArrays, setModifiedArrays] = useState();
  const [ownerArrays, setOwnerArrays] = useState();
  const [show, setShow] = useState(false);
  const [showUploadOptionsArr, setShowUploadOptionsArr] = useState([]);
  const childFuntionRef = useRef(null);

  const showToast = useToast();
  const taskManager = useRef(new TaskManager()).current;


  const addToLength = (n) => {
    setLength(prev => prev + n);
  };


  function random4CharsString() {
    const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    try {
      const arr = new Uint8Array(4);
      if (typeof crypto !== "undefined" && crypto.getRandomValues) {
        crypto.getRandomValues(arr);
      } else {
        arr.forEach((_, i) => (arr[i] = Math.floor(Math.random() * 256)));
      }
      for (let i = 0; i < 4; i++) {
        result += chars[arr[i] % chars.length];
      }
    } catch {
      for (let i = 0; i < 4; i++) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }
    }
    return result;
  }

  function getNewName(srcname) {
    const normalizedSrc = normalizeName(srcname, true);
    const lastDot = normalizedSrc.lastIndexOf(".");
    const extension = lastDot !== -1 ? normalizedSrc.slice(lastDot) : "";
    let name = lastDot !== -1 ? normalizedSrc.slice(0, lastDot) : normalizedSrc;

    const randomString = random4CharsString();
    const maxLength = 80;
    const suffix = "_" + randomString + extension;
    const availableLength = Math.max(0, maxLength - suffix.length);

    if (name.length > availableLength) {
      name = name.slice(0, availableLength);
    }
    name = name.replace(/_+$/g, "");

    return name + suffix;
  }

  const keepTheCopyFiles = () => {
    let tempArr = [...selectedFile];
    showUploadOptionsArr.forEach((conflictFile) => {
      const index = tempArr.findIndex((data) => normalizeName(data.name, true) === conflictFile.name);

      if (index !== -1) {
        const originalFile = tempArr[index];
        const newName = getNewName(originalFile.name);
        const newFile = new File([originalFile], newName, { type: originalFile.type });

        if (originalFile.webkitRelativePath) {
          Object.defineProperty(newFile, 'webkitRelativePath', {
            value: originalFile.webkitRelativePath,
            writable: false,
          });
        }

        tempArr[index] = newFile;
      }
    });
    if (childFuntionRef.current) {
      childFuntionRef.current?.saveHandler(tempArr);
      setShowUploadOptionsArr([]);
    }
  };

  const replaceExistingFiles = async () => {
    try {
      const sourcePath = currentPath.join("/");
      const folderPathArr = [];
      showUploadOptionsArr.forEach((data) => {
        folderPathArr.push(
          (sourcePath.length !== 0 ? "/" : "") + sourcePath + "/" + data.name
        );
      });

      // console.log(promiseRes, "promiseRes");
      if (childFuntionRef.current) {
        childFuntionRef.current?.saveHandler(selectedFile);
        setShowUploadOptionsArr([]);
      }
    } catch (error) {
      // console.log("promiseRes : ", error);
      showToast(error.message, "error");
    }
  };

  const onUploadPress = (choosenOptionNumber) => {
    if (choosenOptionNumber === 0) {
      replaceExistingFiles();
    } else if (choosenOptionNumber === 1) {
      keepTheCopyFiles();
    }
  };

  const showUplodOptionsFunciton = (filesArray) => {
    setShowUploadOptionsArr(filesArray);
  };

  const fetchTrashedFiles = async (formattedPath) => {
    try {

      // await init();
      // const sdk = new Sdk(URL);
      // // sdk.new_sdk(URL);
      // const list = await sdk.trash_list(OrderBy.UpdatedTime);
      const folder = new IzFolder();
      folder.setInTrash(true);
      const list = await folder.getFolderList();
      const names = [];
      const types = [];
      const size = [];
      const modifiedDate = [];
      const owner = [];
      const uuids = [];

      list.forEach((data) => {
        if (data instanceof IzFolder) {
          types.push("folder");
          names.push(data.getFolderName());
          // size.push(data.get_size());
          size.push("");
          modifiedDate.push(data.getLastModifiedDateString());
          // owner.push("Induz");
          owner.push(data.getOwner());
          uuids.push(data.getUuId());
        } else if (data instanceof IzFile) {
          names.push(data.getName());
          types.push("file");
          size.push(data.getSizeString());
          modifiedDate.push(data.getLastModifiedDateString());
          owner.push(data.getOwner());
          uuids.push(data.getFileUuId());
        } else {
          types.push("unknown"); // Fallback if needed
        }
      });
      setNamesArrays(names);
      setTypesArrays(types);
      setSizeArrays(size);
      setModifiedArrays(modifiedDate);
      setOwnerArrays(owner);
      setFilesData(list);
      addToLength(names.length);
      setSelectedFile([]);

    } catch (error) {
      console.error("This is the error::", error);
    }
  };

  const fetchRecentFiles = async (formattedPath) => {
    try {
      let folder;
      if (formattedPath === "/" || formattedPath === "") {
        const fo = new IzFolder();
        folder = fo.getRoot();
      } else {
        // get last folder name
        const fo = new IzFolder();
        folder = fo.folderWithName(formattedPath);
      }
      const list = await folder.getFolderList(0);

      const names = [];
      const types = [];
      const size = [];
      const modifiedDate = [];
      const owner = [];


      list.forEach((data) => {
        if (data instanceof IzFolder) {
          types.push("folder");
          names.push(data.getFolderName());
          // size.push(data.get_size());
          size.push("");
          modifiedDate.push(data.getLastModifiedDateString());
          // owner.push("Induz");
          owner.push(data.getOwner());


        } else if (data instanceof IzFile) {
          names.push(data.getName());
          types.push("file");
          size.push(data.getSizeString());
          modifiedDate.push(data.getLastModifiedDateString());
          owner.push(data.getOwner());
        } else {
          types.push("unknown"); // Fallback if needed
        }
      });
      setNamesArrays(names);
      setTypesArrays(types);
      setSizeArrays(size);
      setModifiedArrays(modifiedDate);
      setOwnerArrays(owner);
      setFilesData(list);
      addToLength(names.length);
      setSelectedFile([]);

    } catch (error) {
      console.error("This is the error::", error);
    }
  };

  const fetchAllFiles = async (formattedPath, selected) => {
    try {
      // console.log("fetch all files called with path ", formattedPath, " and selected ", selected);
      // let folder;
      // if (formattedPath === "/" || formattedPath === "") {
      //   const fo = new IzFolder();
      //   folder = fo.getRoot();
      // } else {
      //   // get last folder name
      //   const fo = new IzFolder();
      //   folder = fo.folderWithName(formattedPath);
      // }
      let list ;
      const fo = new IzFolder();
      let folder=fo.folderWithName(formattedPath);
      if (selected === "Name") {
        list = await folder.getSpacesFolderList(2);
        setCurrentPage(1);
      } else if (selected === "Modified Date") {
        list = await folder.getSpacesFolderList(0);
        setCurrentPage(1);
      } else if (selected === "File Size") {
        list = await folder.getSpacesFolderList(3);
        setCurrentPage(1);
        // console.log("came here");
      } else if (selected === "Created Date") {
        list = await folder.getSpacesFolderList(1);
        setCurrentPage(1);
      } else {
        list = await folder.getSpacesFolderList(1);
        setCurrentPage(1);
      }
      listedFolders.current = folder;
      totalPages.current = (Math.ceil(folder.getTotalItems()/folder.getPageSize()));
      const names = [];
      const types = [];
      const size = [];
      const modifiedDate = [];
      const owner = [];
      list.forEach((data) => {
        if (data instanceof IzFolder) {
          types.push("folder");
          names.push(data.getFolderName());
          // size.push(data.get_size());
          size.push("");
          modifiedDate.push(data.getLastModifiedDateString());
          // owner.push("Induz");
          owner.push(data.getOwner());


        } else if (data instanceof IzFile) {
          names.push(data.getName());
          types.push("file");
          size.push(data.getSizeString());
          modifiedDate.push(data.getLastModifiedDateString());
          owner.push(data.getOwner());
        } else {
          types.push("unknown"); // Fallback if needed
        }
      });

      setNamesArrays(names);
      setTypesArrays(types);
      setSizeArrays(size);
      setModifiedArrays(modifiedDate);
      setOwnerArrays(owner);
      setFilesData(list);
      addToLength(names.length);

      setSelectedFile([]);
    } catch (error) {
      console.error("This is the error::", error);
    }
  };


    const formFilesFoldersFromObjectsInSpace = async (list) => {
    try {
      // let folder;
      // if (formattedPath === "/" || formattedPath === "") {
      //   const fo = new IzFolder();
      //   folder = fo.getRoot();
      // } else {
      //   // get last folder name
      //   const fo = new IzFolder();
      //   folder = fo.folderWithName(formattedPath);
      // }
      // let list ;
      // if (selected === "Name") {
      //   list = await folder.getFolderList(2);
      // } else if (selected === "Modified Date") {
      //   list = await folder.getFolderList(0);
      // } else if (selected === "File Size") {
      //   list = await folder.getFolderList(3);
      //   // console.log("came here");
      // } else if (selected === "Created Date") {
      //   list = await folder.getFolderList(1);
      // } else {
      //   list = await folder.getFolderList();
      // }
      const names = [];
      const types = [];
      const size = [];
      const modifiedDate = [];
      const owner = [];
      const UUIDArrays=[];

      // console.log("list from objects in space",list);
      list.forEach((data) => {
        UUIDArrays.push(data.getUuid());
        let uuid=data.getUuid();
        // console.log("data uuid",uuid);
        if (data.isFolder()) {
          types.push("folder");
          names.push(data.getName());
          // size.push(data.get_size());
          size.push("");
          // modifiedDate.push(data.getLastModifiedDateString());
          modifiedDate.push("default date");
          owner.push("Induz");
          // owner.push(data.getOwner());


        } else {
          names.push(data.getName());
          types.push("file");
          // size.push(data.getSizeString());
          size.push("100 MB");
          // modifiedDate.push(data.getLastModifiedDateString());
          modifiedDate.push("default date");
          // owner.push(data.getOwner());
          owner.push("Induz");
        }
        // } else {
        //   types.push("unknown"); // Fallback if needed
        // }
      });

      setNamesArrays(names);
      setTypesArrays(types);
      setSizeArrays(size);
      setModifiedArrays(modifiedDate);
      setOwnerArrays(owner);
      // console.log("list before setting files data",list);
      setFilesData(list);
      addToLength(names.length);

      setSelectedFile([]);
      setUUIDArrays(UUIDArrays);
      // console.log("FilesData after forming from objects in space",filesData, currentPath);
    } catch (error) {
      console.error("This is the error::", error);
    }
  };

  const fetchFavorites = async (formattedPath) => {
    // Favorites functionality is not implemented yet
    // try {
    //   await init();

    //   let folder;
    //   if (formattedPath === "/") {
    //     folder = Folder.get_root();
    //   } else if (formattedPath === "") {
    //     folder = Folder.get_root();
    //   } else {
    //     // get last folder name
    //     folder = await Folder.folder_with_name(formattedPath);
    //   }
    //   const list = await folder.folder_list(2);

    //   const names = [];
    //   const types = [];


    //   list.forEach((data) => {

    //     if (data instanceof Folder) {
    //       types.push("folder");
    //       names.push(data.get_path());
    //     } else if (data instanceof IzFile) {
    //       names.push(data.get_name());
    //       types.push("file");

    //     } else {
    //       types.push("unknown"); // Fallback if needed
    //     }
    //   });

    //   setNamesArrays(names);
    //   setTypesArrays(types);
    //   setFilesData(list);
    //   addToLength(names.length);
    //   setSelectedFile([]);
    // } catch (error) {
    //   console.error("This is the error::", error);
    // }
  };

const fetchSharedFiles = async (formattedPath) => {
  try {

    // console.log("formattedpath",formattedPath);
    // console.log("currentPath",currentPath);

    const pathParts = formattedPath.split("/").filter(Boolean);
    // console.log("Path parts:", pathParts);
    if (formattedPath === "/shared") {
        // console.log("/shared");
    let share= new Share("","");
    const teams = await share.listTeamOfUsers();

    // console.log("Teams",teams);
    const teamUUIDs = teams.map(team => team.uuid || team.id || ""); // Adjust key as per actual team object
    const teamNames = teams.map(team => ({
      value: team.name || team, // Adjust based on actual team object structure
      label: team.name || team,
    }));
    const finalTeamNames = teamNames.map(team => team.value);
    setNamesArrays(["self", ...finalTeamNames]);
    setUUIDArrays(["self", ...teamUUIDs]);
    const types = ["folder", ...finalTeamNames.map(() => "folder")];
    const sizes = ["", ...finalTeamNames.map(() => "")];
    const modifiedDates = ["", ...finalTeamNames.map(() => "")];
    const owners = ["", ...finalTeamNames.map(() => "")];
    setTypesArrays(types);
    setSizeArrays(sizes);
    setModifiedArrays(modifiedDates);
    setOwnerArrays(owners);
    setFilesData([]);
  } else if (formattedPath === "/shared/self") {
    // console.log("Inside root self");
    let selffolder=new IzFolder();
    selffolder.parentPath="/shared";
    selffolder.folderName="";
    processSharedList(await selffolder.getSharedWithMeFolderList(false));
  } else if (pathParts.length==2 ) {
    let selffolder=new IzFolder();
    let teamName=pathParts[1];
    selffolder.parentPath = `/shared/teams`;
    // console.log("Self.parentpath",selffolder.parentPath);
    selffolder.folderName=teamName;
    processSharedList(await selffolder.getSharedWithMeFolderList(true));

  }else if (formattedPath.startsWith("/shared/teams/")) {
    // console.log("inside team subfolder");
    const newPath = [...currentPath];
    newPath.splice(1, 1);
    setCurrentPath(newPath);
  }
  else {

    if(currentPath[1]==="self"){
      // console.log("Inside self");
          const newPath = [...currentPath];
          newPath.splice(1, 1);
          const joinedPath = newPath.join("/");
          // console.log("Joined path",joinedPath);

          let fo=new IzFolder();
          let folder=fo.folderWithName(joinedPath);
          processSharedList(await folder.getSharedWithMeFolderList(false));
      }

  else{
      // console.log("e");
          const newPath = [...currentPath];
          newPath.splice(1, 1);
          const joinedPath = newPath.join("/");
          let fo=new IzFolder();
          let folder=fo.folderWithName(joinedPath);
          processSharedList(await folder.getSharedWithMeFolderList(false));
    }

  }
  } catch (error) {
    // Handle errors, maybe show a message
    console.error("Error fetching shared files:", error);
  }
};
const getReanderingList = (list) => {
    const names = [];
    const types = [];
    const size = [];
    const modifiedDate = [];
    const owner = [];
    list.forEach((data) => {
      if (data instanceof IzFolder) {
        types.push("folder");
        names.push(data.getFolderName());
        // size.push(data.get_size());
        size.push("");
        modifiedDate.push(data.getLastModifiedDateString());
        // owner.push("Induz");
        owner.push(data.getOwner());
      } else if (data instanceof IzFile) {
        names.push(data.getName());
        types.push("file");
        size.push(data.getSizeString());
        modifiedDate.push(data.getLastModifiedDateString());
        owner.push(data.getOwner());
      } else {
        types.push("unknown"); // Fallback if needed
      }
    });
    setNamesArrays(names);
    setTypesArrays(types);
    setSizeArrays(size);
    setModifiedArrays(modifiedDate);
    setOwnerArrays(owner);
    setFilesData(list);
  };

// Helper function to process shared files/folders
function processSharedList(list) {
  const names = [];
  const types = [];
  const size = [];
  const modifiedDate = [];
  const owner = [];
  const uuids = [];
  list.forEach((data) => {
    if (data instanceof IzFolder) {
      types.push("folder");
      names.push(data.getFolderName());
      size.push("");
      modifiedDate.push(data.getLastModifiedDateString());
      owner.push(data.getOwner());
      uuids.push(data.getUuId());
    } else if (data instanceof IzFile) {
      names.push(data.getName());
      types.push("file");
      size.push(data.getSizeString());
      modifiedDate.push(data.getLastModifiedDateString());
      owner.push(data.getOwner());
      uuids.push(data.getFileUuId());
    } else {
      types.push("unknown");
    }
  });
  setNamesArrays(names);
  setTypesArrays(types);
  setSizeArrays(size);
  setModifiedArrays(modifiedDate);
  setOwnerArrays(owner);
  setFilesData(list);
  addToLength(names.length);
  setSelectedFile([]);
  setUUIDArrays(uuids);
}

  const fetchData = async (path = [], selected) => {

     setNamesArrays([]);
     setTypesArrays([]);
     setSizeArrays([]);
     setModifiedArrays([]);
     setOwnerArrays([]);
     setFilesData([]);
     setLength(0);
    try {
      setCheckedRows({});
      // let formattedPath = path?.length  ? "/external_shared" : `/${path?.join("/")}`;
      let formattedPath=`/${path?.join("/")}`;
      // console.log("formatted path is ",formattedPath);
      if (path.length==1){
        formFilesFoldersFromObjectsInSpace(ObjectsInSpace);
        return;

      }
      // console.log("showing section ",showingSection);
      // const url = URL;
      // const sdk = new Sdk(url);
      // if (path.length === 0 && showingSection + 1 === 2) {
      //   formattedPath = "/shared";
      // }
//TODO: ADD A logic to fetch external shared items and also push the types as IzFile and IzFolder accordingly,before that add type of path in space obj response info of shared objects
      // console.log("Fetching data for path:", formattedPath, "and section:", showingSection + 1);
      if (showingSection + 1 === 0) {
        fetchRecentFiles(formattedPath);
      } else if (showingSection + 1 === 1) {
        // console.log("selected in fetch data",selected);
        fetchAllFiles(formattedPath, selected);
      } else if (showingSection + 1 === 2) {
        fetchSharedFiles(formattedPath);
      } else if (showingSection + 1 === 3) {
        fetchTrashedFiles(formattedPath);
      }
      // console.log("current path in fd", currentPath);

    } catch (error) {

      showToast(error.message, "error");
    }
  };

  useEffect(() => {
    fetchData(currentPath);
  }, [currentPath, showingSection]);

  useEffect(() => {
    // console.log("Current path", currentPath);
    totalPages.current = (listedFolders.current ? Math.ceil(listedFolders.current.getTotalItems()/listedFolders.current.getPageSize()) : 1);
  }, [listedFolders.current]);

  useImperativeHandle(ref, () => ({
    setFilesList,
    setModal,
    setUploadedFiles,
    setIsDropDownVisible,
    setSelectedFile,
    setUploadFolder,
    fetchData,
    getCurrentPath: () => currentPath
  }));

  useEffect(() => {
    if (onStateSync) {
      onStateSync({
        currentPath
      });
    }
  }, [currentPath, onStateSync]);

  const [TaskMonitorVisible, setTaskMonitorVisible] = useState(true);
  
  // Listen for toggle event from homepage header button
  useEffect(() => {
    const handleToggleOperationPanel = () => {
      setTaskMonitorVisible((prev) => !prev);
    };
    
    document.addEventListener("toggleOperationPanel", handleToggleOperationPanel);
    return () => {
      document.removeEventListener("toggleOperationPanel", handleToggleOperationPanel);
    };
  }, []);
  
  return (
    <>
      <TaskMonitor
        taskManager={taskManager}
        TaskMonitorVisible={TaskMonitorVisible}
        setTaskMonitorVisible={setTaskMonitorVisible}
      />
        <div className="tableWithPage">
        <FilesWrapperExternal
          TaskMonitorVisible={TaskMonitorVisible}
          setTaskMonitorVisible={setTaskMonitorVisible}
          ref={childFuntionRef}
          setShow={setShow}
          checkedRows={checkedRows}
          setCheckedRows={setCheckedRows}
          filesList={filesList}
          setFilesList={setFilesList}
          modal={modal}
          setModal={setModal}
          uploadModal={uploadModal}
          setUploadModal={setUploadModal}
          setUploadedFiles={setUploadedFiles}
          uploadedFiles={uploadedFiles}
          setIsDropDownVisible={setIsDropDownVisible}
          isDropDownVisible={isDropDownVisible}
          setCancelUploadModal={setCancelUploadModal}
          cancelUploadModal={cancelUploadModal}
          setShowLoadingProgress={setShowLoadingProgress}
          showLoadingProgress={showLoadingProgress}
          fetchData={fetchData}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          progress={progress}
          setProgress={setProgress}
          timeRemaining={timeRemaining}
          setTimeRemaining={setTimeRemaining}
          data={filesData}
          setCurrentPath={setCurrentPath}
          currentPath={currentPath}
          path={currentPath}
          namesArrays={namesArrays}
          typesArrays={typesArrays}
          sizeArrays={sizeArrays}
          modifiedArrays={modifiedArrays}
          ownerArrays={ownerArrays}
          setShowingSection={setShowingSection}
          showUplodOptionsFunciton={showUplodOptionsFunciton}
          setUploadFolder={setUploadFolder}
          uploadFolder={uploadFolder}
          UUIDArrays={UUIDArrays}
          taskManager={taskManager}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          sortSelected={sortSelected}
          setSortSelected={setSortSelected}
          isSortRotated={isSortRotated}
          setIsSortRotated={setIsSortRotated}
          layout={layout}
          setLayout={setLayout}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          listedFolders={listedFolders}
          getReanderingList={getReanderingList}
        />
        {currentPath.length != 1 && filesData.length > 0 && (
          <div className={`tabletest-pagination-wrapper ${showingSection + 1 === 3 ? 'trash-pagination' : ''}`}>
            <div className="tabletest-pagination-info">
              {(() => {
                const itemsPerPage = listedFolders.current ? listedFolders.current.getPageSize() : 20;
                // Calculate total items: if on last page, use actual count, otherwise estimate
                const totalItems = listedFolders.current
                  ? listedFolders.current.getTotalItems()
                  : filesData.length;
                totalPages.current = Math.ceil(totalItems / itemsPerPage);
                const startItem = (currentPage - 1) * itemsPerPage + 1;
                const endItemExp = currentPage === totalPages.current
                  ? (totalPages.current - 1) * itemsPerPage + filesData.length
                  : currentPage * itemsPerPage;
                const endItem = Math.min(endItemExp, totalItems);
                return `Showing ${startItem} to ${endItem} of ${totalItems} results`;
              })()}
            </div>
            <div className="tabletest-pagination-controls">
              <span className="tabletest-pagination-page-info">
                Page {currentPage} of {totalPages.current}
              </span>
              <div className="tabletest-pagination-arrows">
                <button
                  className="tabletest-pagination-arrow-btn"
                  onClick={async () => {
                    if (listedFolders.current && getReanderingList) {
                      setFetching(true);
                      const list = await listedFolders.current.getPreviousFolderList(currentPage - 1);
                      setFetching(false);
                      setCurrentPage((p) => Math.max(p - 1, 1));
                      getReanderingList(list);
                    }
                  }}
                  disabled={fetching || currentPage === 1}
                  aria-label="Previous page"
                >
                  <svg viewBox="0 0 24 24" width="24" height="24" role="img" aria-label="Previous">
                    <path d="M15 6l-6 6 6 6" fill="none" stroke="darkViolet" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>

                </button>
                <button
                  className="tabletest-pagination-arrow-btn"
                  id="enter-test"
                  onClick={async () => {
                    if (listedFolders.current && getReanderingList) {
                      setFetching(true);
                      const list = await listedFolders.current.getNextFolderList(currentPage);
                      setFetching(false);
                      setCurrentPage((p) => Math.max(p + 1, 1));
                      getReanderingList(list);
                    }
                  }}
                  disabled={fetching || currentPage === totalPages.current}
                  aria-label="Next page"
                >
                  <svg viewBox="0 0 24 24" width="24" height="24" role="img" aria-label="Next">
                    <path d="M9 6l6 6-6 6" fill="none" stroke="darkViolet" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {show && (
        <StorageFail isVisible={show} handleCancel={() => setShow(false)} />
      )}
      {/* <FilesWrapper /> */}
      {showUploadOptionsArr.length !== 0 && (
        <UploadOptions
          onCancelPress={() => {
            setShowUploadOptionsArr([]);
          }}
          showUploadOptionsArr={showUploadOptionsArr}
          onUploadPress={onUploadPress}
        />
      )}
    </>
  );
});

export default memo(YsafeExternal);
